import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import styled from '@mui/material/styles/styled';

const PageDotsContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    gap: '4px',
    alignItems: 'center',
}));

const PageDot = styled(Box)(({ theme, active }) => ({
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    transition: 'background-color 0.3s ease',
    cursor: 'pointer',
}));

const PageDots = ({
    totalPages = 3,
    currentPage = 0,
    onPageChange,
    size = 'medium',
    activeSx,
    inactiveSx,
    hoverSx,
    sx = {},
    ...props
}) => {
    const theme = useTheme();

    activeSx = activeSx || { backgroundColor: theme.palette.figma.white[100] };
    inactiveSx = inactiveSx || {
        backgroundColor: theme.palette.figma.white[20],
    };
    hoverSx = hoverSx || { backgroundColor: theme.palette.figma.white[50] };

    const handleDotClick = index => {
        if (onPageChange && typeof onPageChange === 'function') {
            onPageChange(index);
        }
    };

    const sizeStyles = {
        small: { width: '6px', height: '6px', gap: '3px' },
        medium: { width: '8px', height: '8px', gap: '4px' },
        large: { width: '10px', height: '10px', gap: '5px' },
    };

    const currentSizeStyles = sizeStyles[size] || sizeStyles.medium;

    return (
        <PageDotsContainer
            sx={{
                gap: currentSizeStyles.gap,
                ...sx,
            }}
            {...props}
        >
            {Array.from({ length: totalPages }, (_, index) => (
                <PageDot
                    key={index}
                    // active={index === currentPage}
                    onClick={() => handleDotClick(index)}
                    sx={{
                        width: currentSizeStyles.width,
                        height: currentSizeStyles.height,
                        backgroundColor:
                            index === currentPage
                                ? typeof activeSx === 'function'
                                    ? activeSx(theme)
                                    : activeSx
                                : typeof inactiveSx === 'function'
                                    ? inactiveSx(theme)
                                    : inactiveSx,
                        '&:hover': {
                            backgroundColor:
                                index === currentPage
                                    ? typeof activeSx === 'function'
                                        ? activeSx(theme)
                                        : activeSx
                                    : typeof hoverSx === 'function'
                                        ? hoverSx(theme)
                                        : hoverSx,
                        },
                    }}
                />
            ))}
        </PageDotsContainer>
    );
};

export default PageDots;
